import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header.jsx";
import Sidebar from "../../layouts/Sidebar.jsx";
import { Table } from "antd";
import * as XLSX from "xlsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import alertify from "alertifyjs";
import "../../../node_modules/alertifyjs/build/css/alertify.css";
import "../../../node_modules/alertifyjs/build/css/themes/semantic.css";
import AttendanceView from "./AttendanceView.jsx";
import ApiService from "../../service/httpService.js";

const Attendance = () => {
  //state management
  alertify.set("notifier", "position", "top-right");
  const [isLoding, setisLoding] = useState(false)
  const [datasource, setDataSource] = useState([]);
  const [menu, setMenu] = useState(false);
  const [EditData, setEditData] = useState({})
  const [formData, setFormData] = useState({ fromDate: "", ToDate: "" })
  const [validation, setValidation] = useState({ fromDate: true, ToDate: true })
  const [isExport, setisExport] = useState(false)
  
  
   

  //date formating
  function formatSimpleDate(dateStr) {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  //time colculation
  function addTimes(time1, time2) {
    console.log("times",time1,time2);
    
  const [h1, m1, s1] = time1.split(":").map(Number);
  const [h2, m2, s2] = time2.split(":").map(Number);

  let totalSeconds = s1 + s2;
  let totalMinutes = m1 + m2 + Math.floor(totalSeconds / 60);
  let totalHours = h1 + h2 + Math.floor(totalMinutes / 60);

  totalSeconds = totalSeconds % 60;
  totalMinutes = totalMinutes % 60;

  return `${String(totalHours).padStart(2, '0')}:${String(totalMinutes).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`;
}


  function calculateDailyWorkingHours(data) {
  const newData = [];

  // Loop through each entry
  data.forEach(entry => {
    const { employee_id, date, total_workedTime,inTime } = entry;

    // Find if the same employee and same date already exists
    const existingIndex = newData.findIndex(item => item.employee_id === employee_id && item.date === date);

    if (existingIndex >= 0) {
      // If found, update the existing entry by adding the worked time
      newData[existingIndex].total_workedTime = addTimes(total_workedTime?total_workedTime:"00:00:00", newData[existingIndex].total_workedTime? newData[existingIndex].total_workedTime:'00:00:00');
      newData[existingIndex].inTime=inTime
    } else {
      // If not found, push the current entry as a new one
      newData.push({ ...entry });
    }
  });
    
    console.log(newData);
    

  return newData;
}

  //object filter
  function reorderAndFilterKeys(data, keyOrder) {
  return data.map(obj => {
    const newObj = {};
    keyOrder.forEach(key => {
      if (key in obj) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  });
}


  //fetching employee datas
  const fetchAttendance = async () => {
    setisLoding(true)
    try {
      const res = await ApiService.getPublic(`mp_attendance_report.php?from_date=${formData.fromDate}&to_date=${formData.ToDate}&authToken=`);
      console.log("employee", res);
      setDataSource(calculateDailyWorkingHours(res));
      setisLoding(false)
      if (res === null || res.length === 0) {
        alertify.error("No Data Found");
      }

    } catch (err) {
      console.log("error on fetchAttendance", err);
      setisLoding(false)
    }
  };

  //export button
  useEffect(() => {
    if (datasource.length !== 0) {
      setisExport(true)
    }
    else {
      setisExport(false)
    }
  }, [datasource])


  useEffect(() => {
    for (const key in formData) {
      const value = formData[key];
      if (
        value !== undefined &&
        value !== null &&
        value.toString().trim() !== ""
      ) {
        setValidation((prev) => ({ ...prev, [key]: true }));
      }
    }
  }, [formData]);

  const HandleGenerate = () => {
    let Isvalid = true;
    for (const key in formData) {
      const value = formData[key];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        Isvalid = false;
        setValidation((prev) => ({ ...prev, [key]: false }));
      }
    }

    if (Isvalid) {
      fetchAttendance()
    }
    else {
      alertify.error("Please select both From and To dates!");
    }
  }

  const handleEditClick = (record) => {
    setEditData(record)
    console.log("record ", record)
  }

  const HandleExport = (data) => {

    // Step 1: Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(reorderAndFilterKeys(data,['employee',"mobile","date","inTime","check_in_distance","outTime","check_out_distance","total_workedTime"]));

    // Step 2: Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const now = new Date();
   const pad = (n) => n.toString().padStart(2, "0");
   
   const formattedDate = `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`;
   const formattedTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
   
   
       // Step 3: Write the workbook and trigger download
       XLSX.writeFile(workbook, `Attendance_report_${formattedDate}_${formattedTime}.xlsx`);

  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const columns = [
   
    {
      title: "Name",
      dataIndex: "employee",
      sorter: (a, b) => a.employee.localeCompare(b.employee),
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => formatSimpleDate(text),
    }, {
      title: "InTime",
      dataIndex: "inTime",
      sorter: (a, b) => {
      const toMinutes = t => parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
      return toMinutes(a.inTime) - toMinutes(b.inTime);
      },
    },
    {
     title: "Check In Distance",
     dataIndex:"check_in_distance",
     sorter: (a, b) => a.check_in_distance - b.check_in_distance
   },
     {
      title: "OutTime",
      dataIndex: "outTime",
      sorter: (a, b) => {
      const toMinutes = t => parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
      return toMinutes(a.outTime) - toMinutes(b.outTime);
      },
    },
     {
      title: "Check Out Distance",
      dataIndex: "check_out_distance",
      sorter: (a, b) => a.check_out_distance - b.check_out_distance
    },
     {
      title: "Total Working Time",
      dataIndex: "total_workedTime",
      sorter: (a, b) => {
      const toMinutes = t => parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
      return toMinutes(a.total_workedTime) - toMinutes(b.total_workedTime);
      },
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (text, record) => (
        <div className="table-invoice d-flex align-items-center">
          <div className="dropdown dropdown-action">
            <a
              className="btn-action-icon"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-ellipsis-v" />
            </a>
            <div className="dropdown-menu dropdown-menu-end">
              <ul>
                <li>
                  <a
                    className="dropdown-item"
    
                    data-bs-toggle="modal"
                    data-bs-target="#Attendance-view"
                    onClick={() => { handleEditClick(record) }}
                  >
                    <i className="fe fe-edit me-2" /> view
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ),
    }

  ];


  return (
    <div>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
           <div className="content-page-header flex-column gap-3 ">
                <h5>Attendance</h5>
                <div className="page-content">
                  <div className="list-btn">
                    <ul className="filter-list d-flex align-items-center justify-content-center flex-column flex-md-row">
                       <div className="d-flex flex-column flex-md-row gap-md-0">
                      <li>
                        {/* Search */}
                        <form className="m-0 d-flex align-items-center">
                          <label className="form-label m-0">From</label>
                          <input
                            type="date"
                            className={`form-control ms-2 ${validation.fromDate ? "" : "input-error"
                              }`}
                            value={formData.fromDate}
                            onChange={(e) => setFormData({ ...formData, fromDate: e.target.value })}
                          />
                        </form>
                      </li>
                      <li>
                        {/* Search */}
                        <form className="m-0 d-flex align-items-center">
                          <label className="form-label ms-2 mb-0">To</label>
                          <input
                            type="date"
                            className={`form-control ms-2  ${validation.ToDate ? "" : "input-error"
                              }`}
                            value={formData.ToDate}
                            onChange={(e) => setFormData({ ...formData, ToDate: e.target.value })}
                          />
                        </form>
                      </li>
</div>
                      <div className="d-flex gap-2">
                      <li>
                        <a
                          className="btn btn-primary"
          
                          onClick={HandleGenerate}
                        >
                           <i
                            className="fa fa-cogs me-2"
                            aria-hidden="true"
                          />
                          Generate
                        </a>
                      </li>


                      {isExport && <li>
                        <a
                          className="d-flex align-items-center download-item btn btn-filters"
          
                          download=""
                          onClick={(e) => {
                            e.preventDefault(); HandleExport(datasource);
                          }}
                        >
                          <i className="far fa-file-text me-2" />
                          Export
                        </a>
                      </li>}</div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* /Page line */}
            <div className="super-admin-list-head">
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card-table ">
                  <div className="card-body ">
                    <div className="table-responsive">
                    {isLoding ? <div className="d-flex justify-content-center">
                      <div className="spinner-border" role="status" />
                    </div>
                      : 
                        <Table
                          pagination={{
                          total: datasource.length,
                          showSizeChanger: true,
                          // onShowSizeChange: onShowSizeChange,
                          // itemRender: itemRender,
                        }}
                          columns={columns}
                          dataSource={datasource}
                          rowKey="id"
                        />
                      } </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AttendanceView Emp_data={EditData} fetchAttendance={fetchAttendance} />
    </div>
  );
};

export default Attendance;
